/*!
 * Adapted from pnext/three-loader (https://github.com/pnext/three-loader)
 */
import { Color } from 'three';

export const DEFAULT_MAX_POINT_SIZE = 50;
export const DEFAULT_MIN_NODE_PIXEL_SIZE = 50;
export const DEFAULT_MIN_POINT_SIZE = 1;
export const DEFAULT_PICK_WINDOW_SIZE = 15;
export const DEFAULT_POINT_BUDGET = 3_000_000;
export const MAX_LOADS_TO_GPU = 2;
export const MAX_NUM_NODES_LOADING = 8;
export const UPDATE_THROTTLE_TIME_MS = 100;
export const PERSPECTIVE_CAMERA = 'PerspectiveCamera';
export const COLOR_BLACK = new Color(0, 0, 0);
export const COLOR_WHITE = new Color(1, 1, 1);
export const DEFAULT_EDL_NEIGHBOURS_COUNT = 8;
export const OBJECT_STYLING_TEXTURE_WIDTH = 256;
export const OBJECT_STYLING_TEXTURE_HEIGHT = 256;
